export enum UnitLevelUnderwritingAnswers {
  AnimalBite = "animalBite",
  AutomaticSprinkler = "automaticSprinkler",
  BurglarAlarm = "burglarAlarm",
  BusinessDescription = "businessDescription",
  BusinessEmployeesOnPremises = "businessEmployeesOnPremises",
  BusinessOnPremises = "businessOnPremises",
  DaycareOnPremises = "daycareOnPremises",
  VisitorsInAMonth = "visitorsInAMonth",
  Conviction = "conviction",
  CancellationRenew = "cancellationRenew",
  Mortgage = "mortgage",
  PropertyWithFireProtection = "propertyWithFireProtection",
  SecureRails = "secureRails",
  PleaseDescribe = "pleaseDescribe",
  SourceOfHeat = "sourceOfHeat",
  SourceOfHeatInstallation = "sourceOfHeatInstallation",
  TypeOfFuel = "typeOfFuel",
  DivingBoard = "divingBoard",
  DivingBoardSlideLiabilityExtension = "divingBoardSlideLiabilityExtension",
  FourFeetFence = "fourFeetFence",
  StormMitigationImpactglass = "stormMitigationImpactglass",
  StormMitigationShutters = "stormMitigationShutters",
  StormMitigationFortified = "stormMitigationFortified",
  SwimmingPool = "swimmingPool",
  TrampolineLiability = "trampolineLiability",
  ThermoStaticControl = "thermoStaticControl",
  TrampolineLiabilityExtension = "trampolineLiabilityExtension",
  TrampolineSafetyNet = "trampolineSafetyNet",
  UnitIsTied = "unitIsTied",
  UnrepairedDamages = "unrepairedDamages",
  UtilityServices = "utilityServices",
  ReasonCancellationRenew = "reasonCancellationRenew",
  WroughtIron = "wroughtIron",
}
